require('./bootstrap');

// Import jQuery and make it global
window.$ = window.jQuery = require('jquery');

// Import DataTables
require('datatables.net');
require('datatables.net-bs5');

// Import Select2
require('select2');

// Import SweetAlert2
window.Swal = require('sweetalert2');

// Import Toastr
window.toastr = require('toastr');

// Initialize Toastr
toastr.options = {
    closeButton: true,
    progressBar: true,
    positionClass: 'toast-top-right',
    timeOut: 5000
};

// Import FontAwesome
require('@fortawesome/fontawesome-free/js/all');

// Import Chart.js and make it global
import Chart from 'chart.js/auto';
window.Chart = Chart;

// Import SortableJS and make it global
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// MYOB
require('./myob');

// Session Countdown Timer
require('./session-countdown');

// Initialize Select2 and DataTables
$(document).ready(function () {
    // Initialize Select2
    if ($.fn.select2) {
        $('select.form-select').each(function () {
            if (!$(this).data('select2')) {
                $(this).select2({
                    theme: "bootstrap-5"
                });
            }
        });
    }

    // Initialize DataTables
    if ($.fn.DataTable) {
        $('.dataTable').each(function () {
            if (!$.fn.DataTable.isDataTable(this)) {
                $(this).DataTable({
                    sort: false
                });
            }
        });
    }
});